import React from 'react';
import { Button } from './ui/button';
import { heroImage } from '../mock';
import { Sparkles, ArrowRight } from 'lucide-react';

const Hero = () => {
  const scrollTo = (id) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="home"
      className="relative overflow-hidden bg-gradient-to-b from-pink-50 via-rose-50 to-white pt-16 pb-24 md:pt-24 md:pb-32"
    >
      {/* Decorative dots */}
      <div className="absolute inset-0 pink-dots opacity-40 pointer-events-none" />

      {/* Soft blobs */}
      <div className="absolute -top-24 -left-24 w-96 h-96 bg-pink-200/40 rounded-full blur-3xl pointer-events-none" />
      <div className="absolute -bottom-24 -right-24 w-[420px] h-[420px] bg-rose-200/40 rounded-full blur-3xl pointer-events-none" />

      <div className="relative max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="inline-flex items-center gap-2 bg-white/70 backdrop-blur border border-pink-200 text-pink-600 rounded-full px-4 py-1.5 text-xs sm:text-sm font-semibold tracking-wider fade-in-up">
          <Sparkles className="h-3.5 w-3.5" />
          IN-STUDIO NAIL SERVICES
        </div>

        <h1
          className="font-display text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-bold mt-6 leading-[1.05] fade-in-up"
          style={{ animationDelay: '0.1s' }}
        >
          <span className="gradient-text">Beautiful Nails,</span>
          <br />
          <span className="gradient-text">Expert Care</span>
        </h1>

        <p
          className="mt-6 text-lg sm:text-xl text-gray-600 max-w-2xl mx-auto fade-in-up"
          style={{ animationDelay: '0.2s' }}
        >
          Book Your Perfect Set Today
        </p>

        <div
          className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4 fade-in-up"
          style={{ animationDelay: '0.3s' }}
        >
          <Button
            onClick={() => scrollTo('#booking')}
            className="bg-gradient-to-r from-pink-500 to-rose-500 hover:from-pink-600 hover:to-rose-600 text-white rounded-full px-8 py-6 text-base font-semibold shadow-lg hover:shadow-xl transition-all group"
          >
            Book Appointment
            <ArrowRight className="ml-2 h-4 w-4 group-hover:translate-x-1 transition-transform" />
          </Button>
          <Button
            variant="outline"
            onClick={() => scrollTo('#services')}
            className="border-2 border-pink-400 text-pink-600 hover:bg-pink-50 hover:text-pink-700 rounded-full px-8 py-6 text-base font-semibold transition-all"
          >
            View Services
          </Button>
        </div>

        {/* Hero image */}
        <div
          className="mt-16 md:mt-20 max-w-4xl mx-auto fade-in-up"
          style={{ animationDelay: '0.4s' }}
        >
          <div className="relative rounded-3xl overflow-hidden shadow-2xl shadow-pink-200/50 border border-white/50">
            <div className="absolute inset-0 bg-gradient-to-tr from-pink-500/10 via-transparent to-rose-300/10 pointer-events-none z-10" />
            <img
              src={heroImage}
              alt="Luxury pink nail art showcase"
              className="w-full h-[320px] sm:h-[440px] md:h-[520px] object-cover"
              loading="eager"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
